import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top of page whenever the route changes (via location.pathname).
// On Home (`/`) we only skip when the URL has ?cat or ?q (so pill/search can control scroll).
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (pathname === "/") {
      const params = new URLSearchParams(search);
      if (params.get("cat") || params.get("q")) return;
    }
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, search]);
  return null;
}
